// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3iWGN","right":"Footer_right__1wjKx","buttons":"Footer_buttons__scBYh"};